﻿import $ from "jquery";

function reparseUnobtrusiveValidation(formSelector = "form") {
    $(formSelector).removeData("validator")
        .removeData("unobtrusiveValidation");
    $.validator.unobtrusive.parse(formSelector);
}

export { reparseUnobtrusiveValidation };